<template>
  <section class="card">
    <header v-if="title || $slots.header" class="card-header">
      <slot name="header">
        <h2 class="card-title">{{ title }}</h2>
        <p v-if="subtitle" class="card-subtitle">{{ subtitle }}</p>
      </slot>
    </header>
    <div class="card-body">
      <slot />
    </div>
    <footer v-if="$slots.footer" class="card-footer">
      <slot name="footer" />
    </footer>
  </section>
</template>

<script setup lang="ts">
defineProps<{
  title?: string
  subtitle?: string
}>()
</script>

<style scoped>
.card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.08);
  padding: 20px;
  margin: 16px;
}
.card-header {
  margin-bottom: 12px;
}
.card-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
}
.card-subtitle {
  margin: 4px 0 0;
  color: #6b7280;
  font-size: 14px;
}
.card-footer {
  margin-top: 16px;
  display: flex;
  gap: 8px;
}
</style>
